import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { IAnalysisReport } from '../views/Monitoring/Analysis/Analysis';

const analyzeMonitoring = async (
  monitoringId: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.get('/review-ai/' + monitoringId + '/analyze');
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const create = async (
  monitoringId: string,
  type: string,
  includeDeletedReviews = false,
  dateFrom?: string,
  dateTo?: string
) => {
  try {
    const { data } = await http.post('/review-ai/' + monitoringId + '/create', {
      type: type,
      includeDeletedReviews: includeDeletedReviews,
      dateFrom: dateFrom,
      dateTo: dateTo,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const deleteById = async (analysisId: string) => {
  try {
    const { data } = await http.delete('/review-ai/analyses/' + analysisId);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const purgeById = async (analysisId: string) => {
  try {
    const { data } = await http.delete('/review-ai/analyses/' + analysisId + '/purge');
    return data;
  } catch (error) {
    console.error(error);
  }
};

const listAll = async (): Promise<IAnalysisReport[]> => {
  try {
    const { data } = await http.get('/review-ai/analyses');
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const ReviewAiService = {
  analyzeMonitoring,
  listAll,
  create,
  deleteById,
  purgeById,
};

export default ReviewAiService;
